import { RatingsData, Review } from "types/feedback/feedbackTypes";
import { apiClient } from "../client";

export const getAllFeedback = async (foodCourtId: string): Promise<RatingsData> => {
  
    const response = await apiClient.get<RatingsData>(`/customer/admin/feedback/ratings_stats/${foodCourtId}`, {
       headers:{
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
     });
    return response.data;    
  }
 

  export const getAllReviews = async (foodCourtId: string): Promise<Review[]> => {
  
    const response = await apiClient.get<Review[]>(`/customer/admin/feedback/reviews/${foodCourtId}`, {
       headers:{
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
     });
    return response.data;    
  }
 